import { useFirestoreDoc } from "@p0security/frontend-core/react";
import { Tenant } from "components/Login";
import { useContext } from "react";

type IntegrationOptions = {
  live?: boolean;
};

/** Loads an integration configuration directly from tenant-scoped Firestore. */
export const useIntegration = <T>(
  integration: string,
  options?: IntegrationOptions
) => {
  const tenantId = useContext(Tenant);
  return useFirestoreDoc<T>(
    `o/${tenantId}/integrations/${integration}`,
    options
  );
};
